module.exports = __webpack_public_path__ + "1511a9c6d133906a47d1f4550a59a704.jpg";


//////////////////
// WEBPACK FOOTER
// ./photo.jpg
// module id = 487
// module chunks = 0